export const saveJsonParse = (text: string) => {
  try {
    if (!text) {
      return null
    }

    return JSON.parse(text)
  } catch (e) {
    console.warn('---json parse error', e, text) // eslint-disable-line no-console
  }
}

export const basicFetch = async <TData = any>(
  ...args: Parameters<typeof fetch>
): Promise<TData> => {
  const response = await fetch(...args)
  const data = saveJsonParse(await response.text())

  if (response.ok) {
    return data
  }

  throw {
    response: {
      status: response.status,
      statusText: response.statusText,
      data,
    },
  }
}
